import React from "react";
import { Container } from "./styles";

export default function NoticeBlock({ title, shortDesc, cover, id }) {
	return (
		<Container>
			<a href={`/blog/notice/${id}`} className="notice-btn">
				{cover ? (
					<img src={cover} alt="capa da notícia" />
				) : (
					<div className="imageShadow">
						<p>imagem aparece aqui</p>
					</div>
				)}
				<div className="content">
					<h2 title={title}>{title || "Título de exemplo"}</h2>
					<div className="desc">
						<p style={{ whiteSpace: "pre-wrap" }}>
							{shortDesc || "Resumo breve da notícia..."}
						</p>
						<div className="desc-btn">Saiba mais …</div>
					</div>
				</div>
			</a>
		</Container>
	);
}
